import type { Team, TeamDto } from '../types';

export function teamFromDto(dto: TeamDto): Team {
  return {
    id: dto.id,
    name: dto.team_name,
    sort: dto.team_sort,
  };
}
